import { state } from './state.js';
import { stepsMod } from './steps.js';
import { utils } from './utils.js';
import { preview } from './preview.js';
import { blocks } from './blocks.js';
import { cart } from './cart.js';

export function initPackBuilder() {
  const root = document.getElementById('ac-packbuilder');
  if (!root) return;

  const steps = JSON.parse(root.dataset.steps || '[]');
  const blockData = JSON.parse(root.dataset.blocks || '[]');

  const trad = {
    step: root.dataset.textStep || 'Step',
    addToCart: root.dataset.textAddToCart || 'Add to cart',
    required: root.dataset.textRequired || '(required)',
    requiredExplication: root.dataset.textRequiredExplication || 'indicates a required option',
    missingRequired: root.dataset.textMissingRequired || 'Please select all required items.',
    missingSelection: root.dataset.textMissingSelection || 'Please select at least one item.',
    insufficientStock: root.dataset.textInsufficientStock || 'Insufficient stock for',
    stockAvailable: root.dataset.textStockAvailable || 'Available stock',
    errorCreatingPack: root.dataset.textErrorCreatingPack || 'Error creating the pack.',
    none: root.dataset.textNone || 'Aucun choix',

    stockErrorTitle: root.dataset.textStockErrorTitle || 'Insufficient stock for some products',
    stockErrorMessage: root.dataset.textStockErrorMessage || 'Some products are not available',
    stockErrorStock: root.dataset.textStockErrorStock || 'Stock',
    stockErrorRequested: root.dataset.textStockErrorRequested || 'Requested',
    stockErrorAdjust: root.dataset.textStockErrorAdjust || 'Adjust to',
    stockErrorEdit: root.dataset.textStockErrorEdit || 'Modify my choices'

  };

  root.innerHTML = `
    <div class="acpb-wrapper">
      <div class="acpb-grid">

        <div class="acpb-top-left">
          <div id="acpb-preview-title" class="acpb-preview-title h2"></div>
          <div id="acpb-preview" class="acpb-preview"></div>
        </div>

        <div class="acpb-top-right">
          <div id="acpb-steps" class="acpb-steps"></div>
        </div>

        <div class="acpb-bottom-left" id="acpb-block-1"></div>

        <div class="acpb-bottom-right">
          <div class="acpb-required-div"><span class="acpb-required">*</span> ${trad.requiredExplication}</div>
          <div class="acpb-total">Total : <span id="acpb-total-price">0.00 €</span></div>

          <div class="acpb-actions acpb-qty-actions">
            <div class="qty d-flex justify-content-start align-items-center gap-4">
              <label class="quantity_wanted mb-0">${root.dataset.textQuantity || 'Quantity'}</label>
              <div class="acpb-qty-selector">
              <button type="button" id="acpb-qty-minus" class="acpb-btn">−</button>
              <input type="number" id="acpb-qty" min="1" value="1">
              <button type="button" id="acpb-qty-plus" class="acpb-btn">+</button>
              </div>
            </div>

            <button id="acpb-add" class="acpb-btn acpb-secondary">
              ${trad.addToCart}
            </button>
          </div>

          <div id="acpb-feedback" class="acpb-feedback"></div>
          <div class="acpb-payment-methods" id="acpb-block-2"></div>
        </div>

      </div>
    </div>
  `;

  state.init({
    root,
    steps,
    blocks: blockData,
    trad,
    elements: {
      stepsEl: root.querySelector('#acpb-steps'),
      previewEl: root.querySelector('#acpb-preview'),
      feedbackEl: root.querySelector('#acpb-feedback'),
      addBtn: root.querySelector('#acpb-add'),
      qtyInput: root.querySelector('#acpb-qty'),
      qtyMinusBtn: root.querySelector('#acpb-qty-minus'),
      qtyPlusBtn: root.querySelector('#acpb-qty-plus')
    }
  });

  state.elements.qtyMinusBtn.onclick = () => {
    const v = parseInt(state.elements.qtyInput.value, 10) || 1;
    state.elements.qtyInput.value = Math.max(1, v - 1);
    utils.updateTotal();
  };
  state.elements.qtyPlusBtn.onclick = () => {
    const v = parseInt(state.elements.qtyInput.value, 10) || 1;
    state.elements.qtyInput.value = v + 1;
    utils.updateTotal();
  };

  if (steps[0]?.options?.length) {
    const o = steps[0].options[0];
    state.getSelections()[Number(steps[0].id)] = {
      id_step_option: o.id_step_option,
      id_product: o.id_product,
      id_product_attribute: o.id_product_attribute,
      image: o.image,
      image_webp: o.image_webp,
      image_avif: o.image_avif,
      label: o.label,
      type: steps[0].type,
      price: o.price,
      stock: o.stock,
      id_attribute: o.id_attribute,
      fullname: o.fullname,
      id_attribute_group: o.id_attribute_group
    };
  }

  stepsMod.render();
  preview.render();
  blocks.render();
  utils.updateTotal();

  state.elements.addBtn.addEventListener('click', e => {
    e.preventDefault();
    e.stopPropagation();
    cart.handleAdd();
  });

  const fsid = `step-${steps[0]?.id}`;
  const body = root.querySelector('#'+fsid);
  const header = root.querySelector(`.acpb-step-header[data-toggle="${fsid}"]`);
  if (body && header) {
      body.classList.add('open');
      header.classList.add('open');
      header.querySelector('.acpb-chevron')?.classList.add('open');
  }
}
window.ACPB = { initPackBuilder };
